var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay2 = function SvgPlay2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    fill: "none",
    viewBox: "0 0 41 40"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    x: 1.333,
    y: 1,
    stroke: "currentColor",
    strokeOpacity: 0.85,
    strokeWidth: 2,
    rx: 19
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.9,
    d: "M26.083 18.701c1 .577 1 2.02 0 2.598l-7.5 4.33a1.5 1.5 0 0 1-2.25-1.299v-8.66a1.5 1.5 0 0 1 2.25-1.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    d: "M26.583 22.165c1.667-.962 1.667-3.368 0-4.33l-7.5-4.33c-1.667-.962-3.75.24-3.75 2.165v8.66c0 1.925 2.083 3.127 3.75 2.165z"
  })));
};
export default SvgPlay2;